import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';

import { actionTypes } from './constants';
import { initReqStateImt } from 'common/constants/initialState';

const initInvoicesState = fromJS({
  memberInvoice: null,
  isMemberInvoiceLoading: false,
  invoiceUnitAmount: null,

  balance: null,
  isFetchBalanceLoading: false,

  isUpdateInvoiceLoading: false,

  actionCancelResult: null,
  isCancelResultLoading: false,

  isFetchReceiptLoading: false,

  isUpdateInvoiceUnitLoading: false,

  isAddInvoiceUnitActionLoading: false,

  invoiceShortData: null,
  invoiceShortDataLoading: null,
});

function invoiceOperatingReducer(state = initInvoicesState, action) {
  switch (action.type) {
    case actionTypes.FETCH_MEMBER_INVOICE:
      return state.set('memberInvoice', fromJS(action.payload));
    case actionTypes.FETCH_INVOICE_SHORT_DATA:
      return state.set('invoiceShortData', fromJS(action.payload));
    case actionTypes.FETCH_INVOICE_SHORT_DATA_LOADING:
      return state.set('invoiceUnitCountLoading', fromJS(action.payload));
    case actionTypes.FETCH_MEMBER_INVOICE_LOADING:
      return state.set('isMemberInvoiceLoading', action.payload);
    case actionTypes.FETCH_RECEIPT_LOADING:
      return state.set('isFetchReceiptLoading', action.payload);
    case actionTypes.RESET_MEMBER_INVOICE:
      return state.set('memberInvoice', null);
    case actionTypes.RESET_INVOICE_SHORT_DATA:
      return state.set('invoiceShortData', null);

    case actionTypes.ADD_INVOICE_UNIT_LOADING:
      return state.set('isAddInvoiceUnitActionLoading', action.payload);

    case actionTypes.ADD_INVOICE_UNIT:
    case actionTypes.CHANGE_INVOICE_UNIT_NUMBER:
    case actionTypes.DELETE_INVOICE_UNIT:
      const memberInvoice = state.get('memberInvoice');

      const isNewInvoiceData =
        action.payload.lastModifiedDateLong >
        state.getIn(['memberInvoice', 'lastModifiedDateLong']);

      if (memberInvoice && isNewInvoiceData) {
        return state.update('memberInvoice', () => fromJS(action.payload));
      }

      return state;

    case actionTypes.UPDATE_INVOICE_LOADING:
      return state.set('isUpdateInvoiceLoading', action.payload);

    case actionTypes.CANCEL_INVOICE:
      return state.set('actionCancelResult', fromJS(action.payload));
    case actionTypes.CANCEL_INVOICE_LOADING:
      return state.set('isCancelResultLoading', action.payload);
    case actionTypes.RESET_CANCEL_INVOICE:
      return state.set('actionCancelResult', null);

    case actionTypes.FETCH_BALANCE_BY_CUSTOMER_ID_LOADING:
      return state.set('isFetchBalanceLoading', action.payload);
    case actionTypes.FETCH_BALANCE_BY_CUSTOMER_ID:
      return state.set('balance', fromJS(action.payload));
    case actionTypes.RESET_BALANCE:
      return state.set('balance', null);

    case actionTypes.RESET_INVOICE_OPERATING_STATE:
      return initInvoicesState;
    default:
      return state;
  }
}

const initStateInvoicePaymentMethods = fromJS({
  data: [],
  isLoading: false,
});

function invoicePaymentMethodsReducer(state = initStateInvoicePaymentMethods, action) {
  switch (action.type) {
    case actionTypes.FETCH_AVAILABLE_PAYMENT_METHODS_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.FETCH_AVAILABLE_PAYMENT_METHODS_RESULT:
      return state.set('data', fromJS(action.payload.data));
    case actionTypes.RESET_AVAILABLE_PAYMENT_METHODS:
      return initStateInvoicePaymentMethods;
    default:
      return state;
  }
}

const invoiceStoredCreditCardsState = fromJS({
  creditCards: [],
  isLoading: false,
  addCreditCardResult: null,
  addCreditCardLoading: false,
});

function invoiceStoredCreditCardsReducer(state = invoiceStoredCreditCardsState, action) {
  switch (action.type) {
    case actionTypes.FETCH_STORED_CREDIT_CARDS_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.FETCH_STORED_CREDIT_CARDS_RESULT:
      return state.set('creditCards', fromJS(action.payload));
    case actionTypes.STORE_CREDIT_CARD_RESULT:
      return state.set('addCreditCardResult', action.payload);
    case actionTypes.STORE_CREDIT_CARD_LOADING:
      return state.set('addCreditCardLoading', action.payload);
    case actionTypes.RESET_STORED_CREDIT_CARD_RESULT:
      return state.set('addCreditCardResult', null);
    case actionTypes.RESET_STORED_CREDIT_CARDS_REDUCER:
      return invoiceStoredCreditCardsState;
    default:
      return state;
  }
}

function invoiceSyncActionReducer(state = initReqStateImt, action) {
  switch (action.type) {
    case actionTypes.UPDATE_INVOICE_WITH_SYNC_RESULT:
      return state.set('result', fromJS(action.payload));
    case actionTypes.UPDATE_INVOICE_WITH_SYNC_ERROR:
      return state.set('error', fromJS(action.payload));
    case actionTypes.UPDATE_INVOICE_WITH_SYNC_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.RESET_UPDATE_INVOICE_WITH_SYNC:
      return initReqStateImt;
    default:
      return state;
  }
}

function invoiceCheckoutResultReducer(state = null, action) {
  switch (action.type) {
    case actionTypes.SET_CHECKOUT_RESULT:
      return fromJS(action.payload);
    case actionTypes.RESET_CHECKOUT_RESULT:
      return null;
    default:
      return state;
  }
}

const initCheckingSavingsState = fromJS({
  list: [],
  fetchCheckingSavingsLoading: false,
  addCheckingSavingsLoading: false,
  addCheckingSavingsActionResult: null,
  deleteCheckingSavingsLoading: false,
  deleteCheckingSavingsActionResult: null,
});

function invoiceCheckingSavingsReducer(state = initCheckingSavingsState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CHECKING_SAVINGS_DATA:
      return state.set('list', fromJS(action.payload));
    case actionTypes.FETCH_CHECKING_SAVINGS_DATA_LOADING:
      return state.set('fetchCheckingSavingsLoading', action.payload);
    case actionTypes.ADD_CHECKING_SAVINGS_DATA:
      return state.update('list', data => {
        const routingNumberExists = data
          .toJS()
          .some(el => el.routingNumber === action.payload.routingNumber);
        if (routingNumberExists) {
          return data;
        }
        return fromJS([...(data || []), action.payload]);
      });
    case actionTypes.ADD_CHECKING_SAVINGS_DATA_LOADING:
      return state.set('addCheckingSavingsLoading', action.payload);
    case actionTypes.ADD_CHECKING_SAVINGS_DATA_ACTION_RESULT:
      return state.set('addCheckingSavingsActionResult', action.payload);
    case actionTypes.DELETE_CHECKING_SAVINGS_ITEM:
      return state.update('list', data => {
        const filteredData = data.filter(item => item.get('id') !== action.payload);
        return fromJS(filteredData);
      });
    case actionTypes.DELETE_CHECKING_SAVINGS_ITEM_LOADING:
      return state.set('deleteCheckingSavingsLoading', action.payload);
    case actionTypes.DELETE_CHECKING_SAVINGS_ITEM_ACTION_RESULT:
      return state.set('deleteCheckingSavingsActionResult', action.payload);
    case actionTypes.RESET_CHECKING_SAVINGS_DATA:
      return initCheckingSavingsState;
    default:
      return state;
  }
}

export default combineReducers({
  invoicesOperating: invoiceOperatingReducer,
  invoicePaymentMethods: invoicePaymentMethodsReducer,
  invoiceSyncAction: invoiceSyncActionReducer,
  invoiceStoredCreditCards: invoiceStoredCreditCardsReducer,
  invoiceCheckoutResult: invoiceCheckoutResultReducer,
  invoiceCheckingSavings: invoiceCheckingSavingsReducer,
});
